import { render, staticRenderFns } from "./ModalMyAnswer.vue?vue&type=template&id=af34dba8&scoped=true&lang=pug&"
import script from "./ModalMyAnswer.vue?vue&type=script&lang=ts&"
export * from "./ModalMyAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMyAnswer.vue?vue&type=style&index=0&id=af34dba8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af34dba8",
  null
  
)

export default component.exports